import { Component, OnInit, Output } from '@angular/core';
import { ChildrenOutletContexts, ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import * as $ from 'jquery';
import { fadeInOutAnimation } from 'src/app/animations';

@Component({
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  animations: [fadeInOutAnimation]
})

export class PublicLayoutComponent implements OnInit {

  @Output() header: string;

  constructor(
    private router: Router,
    private contexts: ChildrenOutletContexts
  ) { }

  ngOnInit(): void {
    $('body').addClass('public-layout');

    this.router.events.subscribe((evt) => {
      this.header = 'comun';

      if (evt instanceof Scroll) {
        if (evt.routerEvent['url'] == '/politica-cookies') {
          this.header = 'cookies';
        }
      }

      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      //find js string contains.
      if (evt.url != '/home' && evt.url != '/politica-cookies' && evt.url.indexOf('/admin') < 0 && evt.url.indexOf('/login') < 0) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $('#content-starts').offset().top
        });
      }

    });
  }

  getAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  };

}
